package com.essntl.uikit.key

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.compose.ui.input.key.KeyEvent
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.isCtrlPressed
import androidx.compose.ui.input.key.isMetaPressed
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.type

class KeyboardState {
    var pressedKey by mutableStateOf<KeyEvent?>(null)
        private set

    fun onKeyEvent(keyEvent: KeyEvent?) {
        pressedKey =
            when (keyEvent?.type) {
                KeyEventType.KeyUp ->
                    null
                KeyEventType.KeyDown ->
                    keyEvent
                KeyEventType.Unknown ->
                    pressedKey
                else ->
                    null
            }
    }
}